import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryInpostForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-inpost',
  templateUrl: './inpost.component.html',
  styleUrls: ['./inpost.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InpostComponent {
  delivery = input<DeliveryInpostForm>();
}
